import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {JackpotBetWidgetLogoDefaultBox} from "./jackpot-bet-widget-logo.default.box";


export const JackpotBetWidgetLogoBox = styledByTheme(JackpotBetWidgetLogoDefaultBox)
    // .forMrGreen(JackpotBetWidgetLogoDefaultBox) TODO: Add em when we get logos for MRG and 777
    // .forCasino777(JackpotBetWidgetLogoDefaultBox)
    .apply();